import type { FC, ReactNode } from 'react';

import { CodeChip } from '../../../components/reusable/code-chip';
import { CardItems } from '../../../components/reusable/components';
import { splitElectoralCode } from '../../../components/reusable/helper';
import { useReduxContext } from '../../../context/redux';
import type { IPUSummary } from './utils';

interface IDdRow {
	title: string;
	value: string | number;
	copy?: boolean;
	action?: () => void;
	renderValue?: ReactNode;
}

export const PUSummary: FC<IPUSummary> = ({ puData, rightPanel }) => {
	const metaData = puData?.data;
	if (!metaData) return <></>;
	const parts = splitElectoralCode(metaData.poolingUnitCode);
	const data = metaData
		? [
				{
					title: 'Description',
					value: metaData.description || '',
					details: [],
				},
			]
		: [];
	const ddData: IDdRow[] = metaData
		? [
				{
					title: 'State Name/Code',
					value: `${metaData.state.name} (${parts.state ?? ''})`,
					renderValue: (
						<span className='f-row-7 align-items-center gap-7'>
							<span>{metaData.state.name}</span>
							{parts.state ? (
								<CodeChip
									code={parts.state}
									level='state'
									compact
								/>
							) : null}
						</span>
					),
					action: () => {
						rightPanel?.callSection({
							action: 'view',
							component: 'state-details',
							title: `${metaData.state.name} State`,
							data: {
								id: metaData.state.id,
							},
						});
					},
				},
				{
					title: 'LGA Name',
					value: metaData.lga.name,
				},
				{
					title: 'LGA Code',
					value: parts.lga ?? '',
					renderValue: (
						<CodeChip
							code={parts.lga}
							level='lga'
						/>
					),
				},
				{
					title: 'RA/Ward',
					value: metaData.ward.name,
					copy: true,
				},
				{
					title: 'RA/Ward Code',
					value: parts.ward ?? '',
					renderValue: (
						<CodeChip
							code={parts.ward}
							level='ward'
						/>
					),
				},
				{
					title: 'Polling Unit Name',
					value: metaData.name,
				},
				{
					title: 'Polling Unit Code',
					value: parts.pollingUnit ?? '',
					renderValue: (
						<CodeChip
							code={parts.pollingUnit}
							level='pollingUnit'
							peek={false}
						/>
					),
				},
			]
		: [];

	return (
		<div className='f-column-33 text-left pt-3'>
			<div className='grid-wrapper-40 gap-33 text-left'>
				{ddData.map((i, index) => (
					<div key={index}>
						<CardItems
							title={i.title}
							value={i?.value?.toLocaleString() || ''}
							copy={i.copy}
							onHandleClick={i.action}
							renderValue={i.renderValue}
						/>
					</div>
				))}
			</div>
			<div className='f-column-33 text-left'>
				{data.map((i, index) => (
					<div key={index}>
						<CardItems
							title={i.title}
							value={i.value.toLocaleString()}
						/>
						{/* {i.details?.length ? (
              <details className="f-column-20">
                <summary className="text-tiny color-label mt-2">
                  <i>Click to see more info</i>
                </summary>
                <div className="grid-wrapper-40 gap-33 border-label rounded p-2 mt-2">
                  {i.details.map((detail, dindex) => (
                    <div key={dindex}>
                      <CardItems
                        title={detail.title}
                        value={detail?.value?.toLocaleString() || ''}
                        copy={detail.copy}
                        mini
                      />
                    </div>
                  ))}
                </div>
              </details>
            ) : null} */}
					</div>
				))}
			</div>
		</div>
	);
};

export const PollingUnitDescription = () => {
	const { states } = useReduxContext();
	const metaData = states?._poolingUnit?.get_PoolingUnitByCode?.data;
	if (!metaData) return <></>;

	return <p className='color-label text-little'>{metaData.description}</p>;
};
